import { NgxCurrencyConfig } from "ngx-currency";

export const currencyOptions: Partial<NgxCurrencyConfig> = {
    thousands: ',',
    decimal: '',
    nullable: true,
    allowZero: false,
    precision: 0,
    max: 100000000000
  };